import styled from "styled-components/macro"

export const Image = styled.img`
  border: none;
  outline: none;
  vertical-align: middle;
  width: ${props => props.width || '20px'};
  height: ${props => props.isSquare ? (props.width || '20px') : 'auto'};
  border-radius: ${props => props.isCircle ? '50%' : props.big ? "10px" : props.small ? "5px" : props.borderRadius};
  margin: ${props => props.margin ? props.margin : '0'};
  transform: scaleX(${props => props.flip ? -1 : 1});
  filter: ${props => props.isBright ? 'brightness(0) invert(1)' : 'none'};
  cursor: ${props => props.isLink ? 'pointer' : (props.cursor || 'default')};
  position: ${props => props.position || 'static'};
  top: ${props => props.top};
  right: ${props => props.right};
  border: ${props => props.border || 'none'};

  &.invert {
    filter: none;
  };

  &.inactive {
    filter: grayscale(1);
  };
  
`

export const ImageExtra = styled(Image)`
  flex: ${props => props.flex};
  position: ${props => props.position};
`

export const Banner = styled(Image)`
  width: 100%;
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: 0 0 5px ${props => props.theme.colors.gray[2]};
  cursor: pointer;
`

export const TopImage = styled(Image)`
  width: 100%;
`

export const Icon = styled(Image)`
`

export const CalendarIcon = styled(Icon)`
  width: 25px;
  position: absolute;
  left: ${props => props.theme.left};
  top: ${props => props.theme.top};
`

export const CopyIcon = styled(Icon)`
  opacity: 0.72;
`

export const ButtonIcon = styled(Icon)`
  position: absolute;
  top: 12px;
  right: ${props => props.theme.right};

  @media screen and (max-Width: 320px) {
    width: 16px;
    height: 16px;
    top: 14px;
  }
`

export const Close = styled(Icon)`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`

export const NotificationClose = styled(Close)`
  right: auto;
  top: calc(${props => props.theme.top} + 2px);
  left: ${props => props.theme.left};
`

export const PlanetImage = styled(Image)`
  width: 40px;
  height: 40px;
  &.small {
    width: 20px;
    height: 20px;
    margin: 0 2px 0 8px;
  }
`

export const Toggle = styled(Icon)`
  margin: 4px 6px 6px 6px;
  transition: all .5s ease-in-out;
  transform:  ${props => props.collapsed ? 'rotate(180deg)' : 'none'};
`

export default Image
